import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { DatePipe } from "./pipes/datePipe";
import { ShamsiDatePipe } from "./pipes/shamsiDatePipe";
import { ModalComponent } from "./modal/modal.component";

@NgModule({
    declarations: [
      ModalComponent,
      ShamsiDatePipe,
      DatePipe
    ],
    imports: [CommonModule],
    exports: [
        CommonModule,
        TranslateModule,
        ModalComponent,
        ShamsiDatePipe,
        DatePipe
    ],
    providers:[DatePipe, ShamsiDatePipe]
})
export class SharedModule { }